import $ from 'domtastic';

import eventHub from './eventHub';

const THRESHOLD = 100;

function scrollFunc(e) {
  if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight - THRESHOLD) {
    eventHub.$emit('lazy-load');
  }
}

export default {
  bind(el) {
    $(el).on('scroll', scrollFunc);
  },
  unbind(el) {
    $(el).off();
  }
}